export default "/images/vendor/flag-icons/flags/4x3/ee.svg?bd3f873d66e924740c134ff9940e988f";